<template>
  <div class="has-campaignCuration-component">
    <div class="column is-12">
      <div class="columns">
        <div class="column is-full">
          <p class="is-size-2 is-size-3-mobile has-text-left has-text-primary has-text-weight-bold dm-sans">
            Dados Cadastrais
          </p>
        </div>
      </div>
      <div>
        <div class="columns">
          <div class="column is-full">
            <p class="is-size-4 is-size-5-mobile has-text-left has-text-grey-secondary has-text-weight-bold">
              Responsável Legal
            </p>
          </div>
        </div>
        <div class="columns is-multiline">
          <div class="column is-3-desktop is-full-mobile is-6-tablet">
            <div class="field">
              <label class="label has-text-weight-light is-size-5 is-size-6-mobile">Nome do representante</label>
              <div class="control">
                <input
                    v-validate="'required'"
                    required
                    name="legalGuardianName"
                    class="input"
                    type="text"
                    v-model="formData.legalGuardian.data.name"
                >
              </div>
            </div>
          </div>
          <div class="column is-3-desktop is-full-mobile is-6-tablet">
            <div class="field">
              <label class="label has-text-weight-light is-size-5 is-size-6-mobile">Doc. RG</label>
              <div class="control">
                <input
                    v-validate="'required'"
                    required
                    name="legalGuardianRgDocument"
                    class="input"
                    type="text"
                    v-model="formData.legalGuardian.data.rg_document"
                    v-mask="'##.###.###-X'"
                >
              </div>
            </div>
          </div>
        </div>
        <div class="columns is-multiline">
          <div class="column is-3-desktop is-full-mobile is-6-tablet">
            <div class="field">
              <label class="label has-text-weight-light is-size-5 is-size-6-mobile">Doc. CPF</label>
              <div class="control">
                <input
                v-validate="'required'"
                required
                name="legalGuardianCpfDocument"
                class="input"
                type="text"
                v-model="formData.legalGuardian.data.cpf_document"
                v-mask="['###.###.###-X#', '##.###.###/####-##']"
                >
              </div>
            </div>
          </div>
          <div class="column is-3-desktop is-full-mobile is-6-tablet">
            <div class="field">
              <div class="field-label">
                <label class="label has-text-left has-text-weight-light is-size-5 is-size-6-mobile mb-label">Telefone</label>
              </div>
              <div class="field-body">
                <div class="field is-expanded">
                  <div class="field has-addons">
                    <p class="control">
                      <a class="button is-static has-text-grey-secondary">
                        +55
                      </a>
                    </p>
                    <p class="control is-expanded">
                      <input
                          v-validate="'required|min:14'"
                          required
                          name="legalGuardianPhoneNumber"
                          class="input"
                          type="tel" v-model="formData.legalGuardian.data.phone_number"
                          v-mask="['(##) ####-####', '(##) #####-####']"
                      >
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="columns is-multiline">
          <div class="column is-6-desktop is-full-mobile">
            <div class="field">
              <label class="label has-text-weight-light is-size-5 is-size-6-mobile">Email</label>
              <div class="control">
                <input
                  class="input"
                  v-validate="'required|email'"
                  name="legalGuardianEmail"
                  required
                  type="email"
                  v-model="formData.legalGuardian.data.email"
                >
              </div>
            </div>
          </div>
        </div>

        <div class="columns mt-6">
          <div class="column is-full">
            <p class="is-size-4 is-size-5-mobile has-text-left has-text-grey-secondary has-text-weight-bold">
              Responsável Técnico
              <span class="is-hidden-mobile">(colaborador que vai ficar á frente da operação no dia a dia)</span>
              <span class="is-hidden-tablet tech-manager-note">Colaborador responsável pela operação diária</span>
            </p>
          </div>
        </div>
        <div class="columns is-multiline">
          <div class="column is-3-desktop is-full-mobile is-6-tablet">
            <div class="field">
              <label class="label has-text-weight-light is-size-5 is-size-6-mobile">Nome do responsável</label>
              <div class="control">
                <input
                  class="input"
                  name="technicalManagerName"
                  required
                  v-validate="'required'"
                  type="text"
                  v-model="formData.technicalManager.data.name"
                >
              </div>
            </div>
          </div>
          <div class="column is-3-desktop is-full-mobile is-6-tablet">
            <div class="field">
              <div class="field-label">
                <label class="label has-text-left has-text-weight-light is-size-5 is-size-6-mobile mb-label">Telefone</label>
              </div>
              <div class="field-body">
                <div class="field is-expanded">
                  <div class="field has-addons">
                    <p class="control">
                      <a class="button is-static has-text-grey-secondary">
                        +55
                      </a>
                    </p>
                    <p class="control is-expanded">
                      <input
                          v-validate="'required|min:14'"
                          name="technicalManagerPhoneNumber"
                          required
                          class="input"
                          type="tel" v-model="formData.technicalManager.data.phone_number"
                          v-mask="['(##) ####-####', '(##) #####-####']"
                      >
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="columns mt-6">
          <div class="column is-full">
            <p class="is-size-4 is-size-5-mobile has-text-left has-text-grey-secondary has-text-weight-bold">
              O Pedbot foi indicado por outra pessoa?
            </p>
            <vb-switch type="success" size="large" v-model="hasRecommendation"/>
          </div>
        </div>
        <div class="columns is-multiline" v-if="hasRecommendation">
          <div class="column is-3-desktop is-full-mobile is-6-tablet">
            <div class="field">
              <label class="label has-text-weight-light is-size-5 is-size-6-mobile">Nome da pessoa</label>
              <div class="control">
                <input
                  class="input"
                  name="recommenderName"
                  required
                  v-validate="'required'"
                  type="text"
                  v-model="formData.recommender.data.name"
                >
              </div>
            </div>
          </div>
          <div class="column is-3-desktop is-full-mobile is-6-tablet">
            <div class="field">
              <div class="field-label">
                <label class="label has-text-left has-text-weight-light is-size-5 is-size-6-mobile mb-label">Telefone</label>
              </div>
              <div class="field-body">
                <div class="field is-expanded">
                  <div class="field has-addons">
                    <p class="control">
                      <a class="button is-static has-text-grey-secondary">
                        +55
                      </a>
                    </p>
                    <p class="control is-expanded">
                      <input
                          v-validate="'required|min:14'"
                          name="recommenderPhoneNumber"
                          required
                          class="input"
                          type="tel" v-model="formData.recommender.data.phone_number"
                          v-mask="['(##) ####-####', '(##) #####-####']"
                      >
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="column is-12 pt-6">
      <next-button
        @nextTab="nextTab"
        position="right"
        sizeClass="is-one-third is-fullwidth-mobile"
      ></next-button>
    </div>
  </div>
</template>

<script>

import { mask } from 'vue-the-mask';
import NextButton from './NextButton'
import VbSwitch from 'vue-bulma-switch'

export default {

  name: 'registration-data',
  components: {
    NextButton,
    VbSwitch
  },

  directives: { mask },

  props: {
    formData: {
      required: true,
      type: Object
    }
  },

  data() {
    return {
      hasRecommendation: false
    }
  },

  methods: {
    // change() {
    //   this.hasRecommendation = !this.hasRecommendation
    // },
    nextTab() {
      this.$validator.validate().then((result) => {
        if (result) {
          this.$flashStorage.destroyAll()
          this.$emit('nextTab')
        } else {
          this.$flashStorage.destroyAll()
          this.flashError('Verifique se você preencheu todos os campos corretamente.');
        }
      })
    }
  }

}

</script>

<style lang="scss">
.mb-label {
  margin-bottom: 0.5em;
}

.tech-manager-note {
  display: block;
  font-size: 0.9rem;
  font-weight: normal;
  margin-top: 0.3rem;
}

@media screen and (max-width: 768px) {
  .is-size-5-mobile {
    font-size: 1.1rem !important;
  }
  
  .is-size-6-mobile {
    font-size: 0.9rem !important;
  }
  
  .field {
    margin-bottom: 1rem;
  }
  
  .columns {
    margin-bottom: 0 !important;
  }
  
  .mt-6 {
    margin-top: 1.5rem !important;
  }
  
  .pt-6 {
    padding-top: 1.5rem !important;
  }
}
</style>